// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gw-payment-providers{display:flex;gap:.5rem;list-style-type:none;margin:0;padding:1rem 0 0}.gw-payment-providers li{margin-left:0;padding-left:0}.gw-payment-providers li:before{display:none;visibility:hidden}@media screen and (min-width:769px){.gw-payment-providers{padding-bottom:2.5rem;padding-top:2rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
